module.exports = __webpack_public_path__ + "static/21st-be44af08b97754532226678ec15ec2c2.png";